export default {
  "OrbiitBackground": "_OrbiitBackground_mdbly_1",
  "Content": "_Content_mdbly_11",
  "Card": "_Card_mdbly_29"
};import "ni:sha-256;v-fAFnrg0WyjJ7u-XENVZNliOrO2YW3Uq5sgV-xlTiI";